import React from 'react';

import { useSortable } from '@dnd-kit/sortable';
import { useTheme, alpha } from '@gogame/ui/styles';

import { CSS } from '@dnd-kit/utilities';

import Handle from './Handle';

export function SortableItem({
  hidden,
  disabled,
  animateLayoutChanges,
  getNewIndex,
  elevation,
  children,
  wrapperStyle,
  height,
  ...props
}) {
  const { id } = props;
  const theme = useTheme();
  const {
    isDragging,
    listeners,
    setNodeRef,
    setActivatorNodeRef,
    transform,
    transition,
  } = useSortable({
    id: id,
    animateLayoutChanges,
    disabled,
    getNewIndex,
  });

  return (
    <div
      ref={(el) => {
        setNodeRef(el);
      }}
      style={{
        ...wrapperStyle,
        transform: CSS.Transform.toString(transform), //let dnd-kit do its thing
        transition: transition,
        opacity: isDragging ? 0.8 : disabled ? 0.5 : 1,
        zIndex: isDragging ? 1 : 0,
        position: 'relative',
        boxShadow: theme.shadows[elevation],
        backgroundColor: `${theme.palette.background.paper}`,
        overflow: 'hidden',
        ...(theme.palette.mode === 'dark' && {
          backgroundImage: `linear-gradient(${alpha(
            '#fff',
            0.1
          )}, ${alpha('#fff', 0.1)})`,
        }),
      }}
    >
      {React.Children.map(children, (child) => {
        return (
          React.isValidElement(child) &&
          React.cloneElement(child, {
            height: height,
            handle: (
              <Handle
                ref={(el) => {
                  setActivatorNodeRef(el);
                }}
                {...listeners}
              />
            ),
          })
        );
      })}
    </div>
  );
}

export default SortableItem;
